<template>
  <div class="mt-auto">
    <div class="container-fluid d-flex align-items-center bg-dark px-1 py-1">
      <div class="text-nowrap">
        <span class="text-secondary">v</span>
        <span class="text-secondary">{{ commitDate }}</span>
        <span class="text-secondary">.</span>
        <span class="text-secondary">{{ shortSha }}</span>
      </div>
      <div class="ms-auto"></div>
      <div class="text-nowrap pe-1"><span class="text-light">made&nbsp;by</span></div>
      <img src="/nomeye-logo.svg" class="ny-logo" title="www.nomeye.ch">
      <div class="px-1"><span class="text-light">in</span></div>
      <img src="/switzerland.svg" class="switzlerland-logo" title="Switzerland">
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useBuildStore } from '@/stores';

const buildStore = useBuildStore();

const commitDate = ref('0000-00-00');
const sha = ref('0000000000000000000000000000000000000000');
const shortSha = ref('0000000');

onMounted(async () => {
  await buildStore.fetchAll(false);

  commitDate.value = buildStore.getByKey('CommitDate') || '0000-00-00';
  sha.value = buildStore.getByKey('Sha') || '0000000000000000000000000000000000000000';
  shortSha.value = buildStore.getByKey('ShortSha') || '0000000';
});
</script>

<style scoped>
.ny-logo {
  height: 16px;
  width: auto;
}

.switzlerland-logo {
  height: 16px;
  width: auto;
}
</style>
